import React, { Component } from "react";

import "./WeddingListCard.css";

class WeddingListCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: props.wedding.progress
    };
  }
  onProgress(progress) {
    this.setState({
      progress: progress
    });
  }
  renderProgressBar() {
    const { progress } = this.state;
    return (
      <div className="emptyProgressBar">
        <p className="mb-4 progressBarText">
          {progress ? "completed" : "No plans yet. Start Planning"}{" "}
        </p>
        <p className="progressBar" style={{ width: `${progress}%` }} />
      </div>
    );
  }
  render() {
    const { wedding, isActive } = this.props;
    const { progress } = this.state || 0;
    const activeClass = isActive ? "isActive" : "";
    return (
      <div
        className={`weddingListCard mt-4 ${activeClass}`}
        onClick={() => {
          this.props.onClick(wedding.type.toLowerCase());
        }}
      >
        <h1 className="weddingTypeLabel">
          <strong>{wedding.type}</strong>{" "}
        </h1>
        <p className="progressText m-hidden">{progress}%</p>

        {this.renderProgressBar()}
      </div>
    );
  }
}

export default WeddingListCard;



// WEBPACK FOOTER //
// ./src/Builder/WeddingList/WeddingListCard.js